import React, { useRef } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { useClickAway } from 'ahooks';
import { CSSTransition } from 'react-transition-group';
import Manager from '../components/Manager';
import general from '../../general';

const sorts = [
  { sort: 'hot',             text: '热门交易' },
  { sort: 'havebeenplaying', text: '最近在玩' },
  { sort: 'publish',         text: '最新发布' },
  { sort: 'effective',       text: '性价比高' },
  { sort: 'asc',             text: '价格升序' },
  { sort: 'desc',            text: '价格降序' },
];

/**
 * props:
 *   kw          string
 *   inputText   string
 *   setKw       fn
 *   setInputText fn
 *   sortIng     bool
 *   setSortIng  fn
 *   sort        number
 *   setSort     fn
 *   tmpFilter   object
 *   onFilterOpen fn   — 点击排序按钮时回调，打开 filter 弹框
 */
export default function TradeListHead(props) {
  const {
    kw, inputText, setKw, setInputText,
    sortIng, setSortIng, sort, setSort,
    tmpFilter, onFilterOpen,
  } = props;

  const sortRef = useRef(null);
  useClickAway(() => setSortIng(false), sortRef);

  let isOnComposition = false;

  const handleComposition = (e) => {
    if (e.type === 'compositionend') {
      isOnComposition = false;
      setInputText(e.target.value);
      setKw(e.target.value);
    } else {
      isOnComposition = true;
    }
  };

  const handleChange = (e) => {
    setInputText(e.target.value);
    if (!isOnComposition) setKw(e.target.value);
  };

  return (
    <div className="trade-list-head">
      <CSSTransition in={sortIng} timeout={250} unmountOnExit>
        <div className="tlh-sorts">
          {sorts.map((item, i) => (
            <div
              key={i}
              className={'tlh-sorts-item' + (sort === i ? ' active' : '')}
              onClick={() => { setSort(i); setSortIng(false); }}
            >
              {item.text}
            </div>
          ))}
        </div>
      </CSSTransition>

      <div className="tlh-input" onClick={() => general.history.push('/trade/search')}>
        <img src="/resources/user/ss.png" className="tlh-input-icon" alt="" />
        <input
          type="text"
          value={inputText || ''}
          placeholder="请输入游戏名称"
          onCompositionStart={handleComposition}
          onCompositionUpdate={handleComposition}
          onCompositionEnd={handleComposition}
          onChange={handleChange}
        />
        {(kw || inputText) && (
          <CloseOutlined
            className="tlh-input-close"
            onClick={() => { setKw(''); setInputText(''); }}
          />
        )}
      </div>

      <div
        className="tlh-sort-btn"
        ref={sortRef}
        onClick={() => {
          setFiltering();
          Manager.push({ event_id: 'A-4-13' });
        }}
      >
        <span className="tlh-sort-text">
          {sorts[tmpFilter?.sort]?.text || '热门交易'}
        </span>
        <img src="/resources/trade/down-jt.png" className="tlh-sort-icon" alt="" />
      </div>
    </div>
  );

  function setFiltering() {
    if (onFilterOpen) onFilterOpen();
  }
}
